import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import * as App from '../../app'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu/constants'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

const onEnter = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.CONTENT_TRAINING_URL))
  .map(store.getState)
  .map(({app, training}) => ({
    selectedCommunity: app.selectedCommunity,
    viewState: {
      dateSelect: training.view.dateSelect,
      end: training.view.end,
      filter: {
        ...IsActive.FILTER_STATUS_ACTIVE,
        ...training.view.filter,
      },
      start: training.view.start,
      ...Utils.queryParamsToState(app.urlParams),
    },
  }))
  .mergeMap(({selectedCommunity, viewState}: Types.FetchTrainingData) => [
    Actions.updateUI(viewState),
    Actions.fetchTrainingData(
      selectedCommunity,
      viewState,
     ),
  ])

const filterChange = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(
    IsActive.filterStatusConstant(Constants.FETCH_TRAINING_CONTENT),
    IsActive.filterStatusConstant(Constants.CHANGE_DATE_SELECT),
    Constants.SELECT_TRAINING_DATE_RANGE,
  )
  .filter(() => history.location.pathname.startsWith(Menu.CONTENT_TRAINING_URL))
  .map(() => store.getState())
  .mergeMap(({app, training}) => [
    App.updateUrlParams(Utils.fetchParamsFromState(training)),
    Actions.fetchTrainingData(
      app.selectedCommunity,
      training.view,
    )])

export const epic = ReduxObservable.combineEpics(
  filterChange,
  onEnter,
)



// WEBPACK FOOTER //
// ./src/pages/training/epic.ts